import { useQuery } from 'react-query';
import { getPumps } from '../services/pump-api.service';

export default function usePumps() {
  return useQuery(['pumps'], () => getPumps().then(({ data }) => data));
}
